// VERSIONS
export const UI_VERSION = '20200945';
//Ставим версию для сброса кэша. Случайный набор цифр. Обновить, если переводы не обновляются
export const TRANSLATIONS_VERSION = `20_${String(Date.now())}`;

// ACTIONS
export const SET_USER = 'SET_USER';
export const SET_LOADING_ITEM = 'SET_LOADING_ITEM';
export const REMOVE_LOADING_ITEM = 'REMOVE_LOADING_ITEM';
export const SET_ERROR_ITEM = 'SET_ERROR_ITEM';
export const REMOVE_ERROR_ITEM = 'REMOVE_ERROR_ITEM';
export const SET_COMMON_DATA = 'SET_COMMON_DATA';
export const SET_SHOW_BANNERS = 'SET_SHOW_BANNERS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const CLEAR_ERROR_ITEM = 'CLEAR_ERROR_ITEM';

// PROCESSING
export const PROCESSING_ITEMS = {
  GET_GOODS: 'GET_GOODS',
  GET_PROFILE: 'GET_PROFILE',
  GET_PRICING: 'GET_PRICING',
  GET_AGREEMENTS: 'GET_AGREEMENTS',
  GET_PRIVACY_POLICY: 'GET_PRIVACY_POLICY',
  GET_BLOG: 'GET_BLOG',
  GET_BLOG_PAGE: 'GET_BLOG_PAGE',
  SET_COMMENTS: 'SET_COMMENTS',
  GET_CONTENT: 'GET_CONTENT',
  GET_GALLERY_PROJECTS: 'GET_GALLERY_PROJECTS',
  GET_LIBRARY: 'GET_LIBRARY',
  SEND_FORM: 'SEND_FORM',
  OPEN_PROJECT: 'OPEN_PROJECT',
  GET_HELP: 'GET_HELP',
  GET_HELP_SECTION: 'GET_HELP_SECTION',
  GET_HELP_CONTENT: 'GET_HELP_CONTENT',
  GET_PERSONAL_DATA_PROCESSING: 'GET_PERSONAL_DATA_PROCESSING',
  GET_LEGAL_INFO: 'GET_LEGAL_INFO',
};

// ENV
export const ENVIRONMENT = process.env.NODE_ENV;
export const HOSTNAME = process.env.HOSTNAME;
export const GTM_ID = process.env.GTM_ID;
export const GTM_ID_STANDALONE = process.env.GTM_ID_STANDALONE;
export const IS_DEVELOPMENT = ENVIRONMENT === 'development';
export const IS_PRODUCTION = ENVIRONMENT === 'production';
export const IS_SERVER = typeof window === 'undefined';
export const IS_CLIENT = typeof window !== 'undefined';
export const USE_LOCAL_JSON = process.env.USE_LOCAL_JSON === 'true';
export const IS_PRODUCTION_HOST = process.env.IS_PRODUCTION_HOST === 'true';

// COOKIES
export const POP_SESSION = 'POP_SESSION';
export const PHP_SESSION = 'PHPSESSID';
export const POP_PROFILE = 'POP_PROFILE';
export const POP_SELECTED_LOCALE = 'POP_SELECTED_LOCALE';
export const RT = 'rt'; // refresh token

// LOCAL STORAGE
export const POP_CURRENT_TEAM = 'POP_CURRENT_TEAM';
export const POP_COOKIES_AGREEMENT = 'POP_COOKIES_AGREEMENT';
export const POP_SOCIAL_AUTH_METHOD = 'POP_SOCIAL_AUTH_METHOD';
export const POP_HIDDEN_HEADER_BANNER = 'POP_HIDDEN_HEADER_BANNER';
export const POP_HIDDEN_CARD_BANNER = 'POP_HIDDEN_CARD_BANNER';
export const POP_RUN_DOWNLOAD = 'POP_RUN_DOWNLOAD';
export const POP_RUN_SCRIPT = 'POP_RUN_SCRIPT';
export const POP_IS_IFRAME_VIEW = 'POP_IS_IFRAME_VIEW'; // Просмотр без шапки и футера

// ALIASES
export const DURATION_ALIAS = {
  '30 days': 1,
  '180 days': 6,
  '360 days': 12,
};

export const HEADER_ANIMATIONS = {
  NONE: 'NONE',
  SHOW: 'SHOW',
  HIDE: 'HIDE',
};

export const BLOG_CATEGORIES = {
  ARTICLES: 'articles',
  UPDATES: 'updates',
  OPINIONS: 'opinions',
  NEWS: 'news',
  INTERVIEW: 'interview',
  INSTRUCTIONS: 'instructions',
  STUDY_PROGRAMMES: 'study-programmes',
};

export const HELP_CENTER = {
  MAIN: 'help-center',
  DOCUMENTATION: 'documentation',
  TROUBLES: 'troubleshooting',
  VIDEOS: 'video-tutorials',
  KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
  LEARNING_MODULES: 'learning-modules',
};

export const EDUCATION_CATEGORIES = {
  VIDEOS: 'videos',
  BUTTONS: 'buttons',
  INSTRUCTIONS: 'instructions',
  COURSES: 'courses',
};

export const EDUCATION_VIDEOS_SUB_CATEGORIES = {
  BASIC: 'basic',
  PRO: 'pro',
  TEAM: 'team',
  VISUAL: 'visual',
  DRAWINGS: 'drawings',
};

export const ERROR_MESSAGE_CATEGORIES = {
  SUBSCRIBE: 'subscribe',
  DEFAULT: 'default',
};

export const OS = {
  WINDOWS: 'windows',
  MAC: 'mac',
};

export const OS_ALIAS = {
  windows: OS.WINDOWS,
  mac: OS.MAC,
};

export const BANNERS = {
  HEADER: 'HEADER',
  CARD: 'CARD',
};

export const SOCIAL_METHODS = {
  google: 'google',
  facebook: 'facebook',
  vk: 'vk',
};

export const GOOGLE_OPTIMIZE_ID = IS_PRODUCTION_HOST ? 'DD4xQsUcSC-PtVnp3j2x3g' : 'QRjsi0j8SL-RnDuVBUB9Uw';

export const GALLERY_PATH = 'gallery';

export const TARIFF_ALIAS = {
  START: 'start',
  PRO: 'pro',
  PROPLUS: 'proplus',
  BUSINESS: 'businessvr',
  EDUCATION: 'education',
  PROFESSIONAL: 'professional',
};

export const BUSINESS_LINK = 'site.business_link';

export const OS_MAC_INTEL_RU =
  'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/ru/PlanoplanSetup.pkg';
export const OS_MAC_SILICON_RU =
  'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/ru/PlanoplanSetup_silicon.pkg';
export const OS_MAC_INTEL_EN = 'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/PlanoplanSetup.pkg';
export const OS_MAC_SILICON_EN =
  'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/PlanoplanSetup_silicon.pkg';
export const OS_WINDOWS_EN = 'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/PlanoplanSetup.msi';
export const OS_WINDOWS_RU = 'https://nocdnfiles.planoplan.com/upload/standalone_build/releases/ru/PlanoplanSetup.msi';

export const HELP_ARTICLES_PER_PAGE = 12;
export const HELP_VIDEO_PER_PAGE = 9;
export const OVERAGE_READING_TIME = 4;
export const HELP_CENTER_ARTICLES_MAX_LIMIT = 10000;
